import { compose } from 'redux';

import SettingsReducer from './settings';
import UserReducer from './user';
import VendorsReducer from './vendors';
import StepsReducer from './steps';
import LoaderReducer from './loading';
import SessionReducer from './session';
import ErrorsReducer from './errors';
import MetricsReducer from './metrics';

const reducers = compose({
  SettingsReducer,
  UserReducer,
  VendorsReducer,
  StepsReducer,
  LoaderReducer,
  SessionReducer,
  ErrorsReducer,
  MetricsReducer,
});

export default reducers;
